<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container>
            <v-card>
                <v-card-title><font color="orange darken-4">ข้อมูลการจัดรถ</font></v-card-title>
                <v-divider></v-divider>
                <v-card-text>

                    <!-- ค้นหาตามที่เลือก -->
                    <v-layout wrap>
                        <v-flex lg2 md3 sm3 xs5 mr-3>
                            <v-menu v-model="menuDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                             offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="searchDate" label="วันที่ส่งของ:" prepend-icon="mdi-calendar" v-on="on" 
                                    color="orange accent-3"></v-text-field>
                                </template>
                                <v-date-picker type="date" v-model="searchDate" @input="menuDate = false" color="orange accent-3"
                                @change="getDeliveryList"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex lg2 md2 sm3 xs4 mr-2>
                            <v-text-field v-model="searchTransNo" label="ค้นหาเลขที่ใบจัดรถ:" 
                            @keypress.enter="getTransNo" ref="searchTransNo" color="orange accent-3"></v-text-field>
                        </v-flex>
                        <v-flex mt-2>
                            <v-layout>
                                <v-flex pr-2>
                                    <v-btn fab small @click="getTransNo" color="orange accent-4">
                                        <v-icon color="white">mdi-magnify</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex lg12 md12 sm12 xs12>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn fab small color="orange accent-4" @click="exportExcel" v-on="on">
                                                <v-icon color="white">mdi-file-export</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>ดาวน์โหลดข้อมูลลูกค้าที่ต้องส่งสินค้า เป็นไฟล์ Excel</span>
                                    </v-tooltip>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>

                    <!-- รายการจัดรถ -->
                    <v-data-table :headers="listHeader" :items-per-page="1000" :items="manageList" hide-default-footer
                     class="elevation-1" dense sort-by="transNo" sort-desc>
                        <template v-slot:no-data>
                            <v-progress-linear v-if="searchData"  height="10px" v-slot:progress color="orange accent-3" 
                            indeterminate></v-progress-linear>
                            <v-flex v-if="noData">
                                <strong><font color="red">ไม่พบข้อมูล</font></strong>
                            </v-flex>
                        </template>
                        <!-- <template v-slot:item.excelAddress="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-hover v-slot:default="{ hover }">
                                        <v-icon :color="hover ? 'orange accent-4' : null" 
                                        @click="exportExcel(item)" v-on="on">mdi-file-export</v-icon>
                                    </v-hover>
                                </template>
                                <span>แปลงไฟล์ Excel เลขที่ {{item.transNo}}</span>
                            </v-tooltip>
                        </template> -->
                        <template v-slot:item.action="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-hover v-slot:default="{ hover }">
                                        <v-icon class="mr-2" :color="hover ? 'orange accent-4' : null" 
                                        @click="editManageCar(item)" v-on="on">mdi-file-document-edit</v-icon>
                                    </v-hover>
                                </template>
                                <span>แก้ไขใบส่งสินค้า {{item.transNo}}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-hover v-slot:default="{ hover }">
                                        <v-icon class="mr-2" :color="hover ? 'orange accent-4' : null" 
                                        @click="infoSo(item)" v-on="on">mdi-file-document-box-search</v-icon>
                                    </v-hover>
                                </template>
                                <span>แสดงรายละเอียด ของใบส่งสินค้า {{item.transNo}}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-hover v-slot:default="{ hover }">
                                        <v-icon @click="printDelivery(item)" :color="hover ? 'orange accent-4' : null" 
                                        v-on="on">mdi-printer</v-icon>
                                    </v-hover>
                                </template>
                                <span>พิมพ์ใบส่งสินค้า</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>

                    <!-- แสดงขัอมูลการจัดรถที่เลือก -->
                    <v-dialog v-model="dialogView" max-width="1220px">
                        <v-card>
                            <v-card-title class="headline">
                                <v-layout wrap>
                                    <v-flex lg3 md3 sm6 xs10>
                                        <font color="orange accent-5">ใบขนส่งสินค้า</font>
                                    </v-flex>
                                    <v-flex text-right>
                                        <v-icon @click="dialogView = false">mdi-close</v-icon>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>
                            <v-divider></v-divider>
                            <br>
                            <v-card-text>
                                <!-- วันที่ขึ้นของ และ วันที่ส่งของ -->
                                <v-layout justify-lg-end justify-md-end justify-sm-end wrap>
                                    <v-flex lg2 md2 sm2 xs12 text-lg-right text-md-right text-sm-right text-xs-left mr-2>วันที่ขึ้นของ: </v-flex>
                                    <v-flex lg2 md3 sm3 xs12>
                                        <input v-model="loadDate" type="text" class="line" disabled>
                                    </v-flex>
                                    <v-flex lg2 md2 sm2 xs12 text-lg-right text-md-right text-sm-right text-xs-left mr-2>วันที่ส่งของ: </v-flex>
                                    <v-flex lg2 md3 sm3 xs12 text-xs-left>
                                        <input v-model="deliveryDate" type="text" class="line" disabled>
                                    </v-flex>
                                </v-layout>

                                <!-- รายละเอียดคนขับรถ และ ทะเบียนรถ -->
                                <v-layout justify-lg-end justify-md-end justify-sm-end wrap>
                                    <v-flex lg2 md2 sm2 xs12 text-lg-right text-md-right text-sm-right text-xs-left mr-2>ชื่อคนขับรถ: </v-flex>
                                    <v-flex lg3 md4 sm4 xs12>
                                        <input v-model="driver" type="text" class="line" disabled>
                                    </v-flex>
                                    <v-flex lg1 md2 sm2 xs12 text-lg-right text-md-right text-sm-right text-xs-left mr-2>เลขทะเบียน: </v-flex>
                                    <v-flex lg2 md2 sm2 xs12>
                                        <input v-model="regNum" type="text" class="line" disabled>
                                    </v-flex>
                                </v-layout>

                                <!-- เลขที่ -->
                                <v-layout wrap>
                                    <v-flex lg1 md1 sm1 xs12 text-lg-right text-md-right text-sm-right text-xs-left mr-2>เลขที่:</v-flex>
                                    <v-flex lg1 md1 sm2 xs6>
                                        <input v-model="transNo" type="text" class="line" disabled>
                                    </v-flex>
                                </v-layout>

                                <!-- Loop รายการจัดส่ง -->
                                <v-layout v-for="(item,i) in listDelivery" :key="i">
                                    <v-flex>
                                        <br>
                                        <v-layout wrap>
                                            <v-flex lg1 md1 sm1 xs12 text-lg-right text-md-right text-sm-right text-xs-left mr-2>จังหวัด:</v-flex>
                                            <v-flex lg2 md2 sm3 xs8>
                                                <input v-model="item.city" type="text" class="line" disabled>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout wrap>
                                            <v-flex lg1 md1 sm1 xs12 text-lg-right text-md-right text-sm-right text-xs-left mr-2>รหัสร้านค้า:</v-flex>
                                            <v-flex lg2 md2 sm3 xs8>
                                                <input v-model="item.cardCode" type="text" class="line" disabled>
                                            </v-flex>
                                            <template v-if="item.cardPhone != ''">
                                                <v-flex lg1 md1 sm1 xs12 text-lg-right text-md-right text-sm-right text-xs-left mr-2>โทรศัพท์:</v-flex>
                                                <v-flex lg4 md4 sm5 xs12>
                                                    <input v-model="item.cardPhone" type="text" class="line" disabled>
                                                </v-flex>
                                            </template>
                                        </v-layout>
                                        <v-layout wrap>
                                            <v-flex lg1 md1 sm1 xs12 text-lg-right text-md-right text-sm-right text-xs-left mr-2>ชื่อร้านค้า:</v-flex>
                                            <v-flex lg7 md7 sm8 xs12>
                                                <input v-model="item.cardName" type="text" class="line" disabled>
                                            </v-flex>
                                        </v-layout>
                                        <br>
                                        <v-divider></v-divider>
                                        <v-card>
                                            <v-card-text v-if="item.custName != ''">
                                                <v-layout wrap>
                                                    <v-flex lg1 md1 sm1 xs12 text-lg-right text-md-right text-sm-left 
                                                    text-xs-left mr-2>ชื่อลูกค้า:</v-flex>
                                                    <v-flex lg4 md4 sm10 xs12>
                                                        <input v-model="item.custName" type="text" class="line" disabled>
                                                    </v-flex>
                                                    <v-flex lg1 md1 sm1 xs12 text-lg-right text-md-right text-sm-left 
                                                    text-xs-left mr-2>โทรศัพท์:</v-flex>
                                                    <v-flex lg3 md3 sm6 xs12>
                                                        <input v-model="item.custTel" type="text" class="line" disabled>
                                                    </v-flex>
                                                    <v-flex lg1 md1 sm1 xs12 text-lg-right text-md-right text-sm-center 
                                                    text-xs-left mr-2>เวลา:</v-flex>
                                                    <v-flex lg1 md1 sm2 xs12>
                                                        <input v-model="item.time" type="text" class="line" disabled>
                                                    </v-flex>
                                                    <!-- <v-flex lg1 md1 sm1 xs3 text-lg-right text-md-right text-sm-center 
                                                    text-xs-left mr-2>นัดแล้ว:</v-flex>
                                                    <v-flex>
                                                        <img src="@/assets/chkbox_logo.png" height="25" width="25">
                                                    </v-flex> -->
                                                </v-layout>
                                                <v-layout wrap>
                                                    <v-flex lg1 md1 sm1 xs12 text-lg-right text-md-right text-sm-center 
                                                    text-xs-left mr-2>ที่อยู่:</v-flex>
                                                    <v-flex>
                                                        <input v-model="item.custAddress" type="text" class="line" disabled>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-text>
                                            <v-divider></v-divider>
                                            <v-data-table :headers="prodHeader" :items="item.prodList" class="elevation-1" 
                                            sort-by="soNo" :items-per-page="100" hide-default-footer dense></v-data-table>
                                            <v-layout>
                                                <v-flex lg6 md6 sm6 xs6 text-right><strong>รวม</strong></v-flex>
                                                <v-flex lg2 md2 sm2 xs5 text-right>
                                                    <strong>
                                                        {{item.totalVolume.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                                                    </strong>
                                                </v-flex>
                                            </v-layout>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-dialog>

                    <!-- แสดงหน้าแก้ไขเวลาจัดส่ง -->
                    <v-dialog v-model="dialogEditSO" max-width="300px" persistent>
                        <v-card>
                            <v-card-text>
                                <br>
                                <v-layout>
                                    <v-flex v-if="editSoNo"><strong>เลขที่ SO: {{editSoNo}}</strong></v-flex>
                                    <v-flex v-else><strong>เลขที่ RT: {{editRtNo}}</strong></v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex v-if="editCustName"><strong>ชื่อลูกค้า: {{editCustName}}</strong></v-flex>
                                    <v-flex v-else><strong>ชื่อร้านค้า: {{editCardName}}</strong></v-flex>
                                </v-layout>
                                <br>
                                <v-divider></v-divider>
                                <v-layout>
                                    <v-flex mr-2>
                                        <v-text-field v-model="editTimeSt" label="เริ่มส่งเวลา:" v-mask="'##:##'" suffix="น." 
                                        color="orange accent-3" ref="editTimeSt"></v-text-field>
                                    </v-flex>
                                    <v-flex>
                                        <v-text-field v-model="editTimeEnd" label="สิ้นสุดส่งเวลา:" v-mask="'##:##'" suffix="น." 
                                        color="orange accent-3" ref="editTimeEnd"></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-divider></v-divider>
                                <br>
                                <v-layout>
                                    <v-flex text-right mr-2>
                                        <v-btn text color="green" @click="confiEditSO">ตกลง</v-btn>
                                    </v-flex>
                                    <v-flex text-left>
                                        <v-btn text color="red" @click="dialogEditSO = false">ยกเลิก</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-dialog>

                    <!-- แสดง So ที่อยู่ในใบจัดส่งสินค้าเลขที่ที่เลือก -->
                    <v-dialog v-model="dialogSO" max-width="300" persistent>
                        <v-card>
                            <v-card-text>
                                <br>
                                <v-layout wrap justify-center>
                                    <v-flex mt-2 mr-2 ml-2 v-for="(item,i) in itemSoNo" :key="i">
                                        <v-hover v-slot:default="{ hover }">
                                            <v-card :elevation="hover ? 8 : 2">
                                                <v-card-text>
                                                    <v-layout wrap>
                                                        <template v-if="item.soNo">
                                                            <v-flex><strong>เลขที่ SO:</strong></v-flex>
                                                            <v-flex text-right>{{item.soNo}}</v-flex>
                                                        </template>
                                                        <template v-else>
                                                            <v-flex><strong>เลขที่ RT:</strong></v-flex>
                                                            <v-flex text-right>{{item.rtNo}}</v-flex>
                                                        </template>
                                                    </v-layout>
                                                    <v-layout wrap>
                                                        <template v-if="item.custName">
                                                            <v-flex><strong>ชื่อลูกค้า:</strong></v-flex>
                                                            <v-flex text-right>{{item.custName}}</v-flex>
                                                        </template>
                                                        <template v-else>
                                                            <v-flex><strong>ชื่อร้านค่า:</strong></v-flex>
                                                            <v-flex text-right>{{item.cardName}}</v-flex>
                                                        </template>
                                                    </v-layout>
                                                </v-card-text>
                                                <v-fade-transition>
                                                    <v-overlay v-if="hover" absolute>
                                                        <v-layout>
                                                            <v-flex text-right mr-2>
                                                                <v-btn fab small @click="editSO(item)" 
                                                                color="orange accent-3" dark><v-icon>mdi-pencil</v-icon></v-btn>
                                                            </v-flex>
                                                            <v-flex text-left>
                                                                <v-btn fab small @click="openConfiDelSO(item)" 
                                                                color="red" dark><v-icon>mdi-delete-forever</v-icon></v-btn>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-overlay>
                                                </v-fade-transition>
                                            </v-card>
                                        </v-hover>
                                    </v-flex>
                                </v-layout>
                                <br>
                                <v-divider></v-divider>
                                <br>
                                <v-layout>
                                    <v-flex text-center>
                                        <v-btn text @click="dialogSO = false">ปิด</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-dialog>

                    <!-- แสดงหน้าแก้ไขใบจัดส่งสินค้า -->
                    <v-dialog v-model="dialogEditManageCar" max-width="900" persistent>
                        <v-card>
                            <v-card-text>
                                <br>
                                <v-layout justify-center wrap>
                                    <v-flex lg1 md1 sm2 mr-2>
                                        <v-text-field v-model="mcTransNo" label="เลขที่:" 
                                        color="orange accent-3" readonly></v-text-field>
                                    </v-flex>
                                    <v-flex lg2 md2 sm3 mr-2>
                                        <v-menu v-model="menuEditLoadDate" :close-on-content-click="false" 
                                        :nudge-right="40" transition="scale-transition"
                                        offset-y min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field v-model="mcLoadDate" label="วันที่ขึ้นของ:" v-on="on" 
                                                color="orange accent-3" readonly></v-text-field>
                                            </template>
                                            <v-date-picker type="date" v-model="mcLoadDate" :min="nowDate" @change="dateTransNo"
                                            @input="menuEditLoadDate = false" color="orange accent-3"></v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex lg2 md2 sm3 mr-2>
                                        <v-menu v-model="menuEditDelDate" :close-on-content-click="false" 
                                        :nudge-right="40" transition="scale-transition"
                                        offset-y min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field v-model="mcDelDate" label="วันที่ส่งของ:" v-on="on" 
                                                color="orange accent-3" readonly></v-text-field>
                                            </template>
                                            <v-date-picker type="date" v-model="mcDelDate" 
                                            @input="menuEditDelDate = false" color="orange accent-3" :min="mcLoadDate"></v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex lg3 md3 sm5 mr-2>
                                        <v-autocomplete :items="driverItem" v-model="mcDriver" 
                                        label="ชื่อคนขับรถ:" color="orange accent-3" 
                                        item-color="orange accent-3" ref="driver"></v-autocomplete>
                                    </v-flex>
                                    <v-flex lg2 md2 sm5>
                                        <v-autocomplete :items="regNumItem" v-model="mcRegNum" 
                                        label="ชื่อคนขับรถ:" color="orange accent-3" 
                                        item-color="orange accent-3" ref="driver"></v-autocomplete>
                                    </v-flex>
                                </v-layout>
                                <v-divider></v-divider>
                                <br>
                                <v-layout>
                                    <v-flex text-right mr-2>
                                        <v-btn text color="green" @click="confiEditManageCar">ตกลง</v-btn>
                                    </v-flex>
                                    <v-flex text-left>
                                        <v-btn text color="red" @click="dialogEditManageCar = false">ยกเลิก</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-dialog>

                </v-card-text>
            </v-card>
        </v-container>

        <!-- Dialog progress -->
        <v-dialog v-model="showDialogProgress" max-width="80" persistent>
            <div class="text-center">
                <v-card>
                    <v-card-text>
                        <v-progress-circular :size="30" color="orange accent-5" indeterminate></v-progress-circular>
                    </v-card-text>
                </v-card>
            </div>
        </v-dialog>

        <!-- Dialog Warning -->
        <v-dialog v-model="showWarning" :max-width="msgWarning.length*8" open-on-hover persistent>
            <div class="text-center">
                <v-card>
                    <v-card-text>
                        <v-layout>
                            <v-flex>
                                <v-icon color="yellow accent-4" :size="45">mdi-alert-circle-outline</v-icon>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                {{msgWarning}}
                            </v-flex>
                        </v-layout>
                        <br>
                        <v-divider></v-divider>
                        <br>
                        <v-layout>
                            <v-flex text-right mr-1>
                                <v-btn text @click="confiDel" color="green" dark>ตกลง</v-btn>
                            </v-flex>
                            <v-flex text-left ml-1>
                                <v-btn text color="red" @click="showWarning = false" dark tabindex="-1">ยกเลิก</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </div>
        </v-dialog>

        <!-- Dialog Error -->
        <v-dialog v-model="showDialogError" width="unset">
            <div class="text-center">
                <v-card>
                    <v-card-text>
                        <v-layout>
                            <v-flex>
                                <v-icon color="red" :size="45">mdi-close-circle-outline</v-icon>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                {{msgError}}
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </div>
        </v-dialog>

        <!-- Dialog Success -->
        <v-dialog v-model="showDialogSuccess" max-width="110" persistent>
            <div class="text-center">
                <v-card>
                    <v-card-text>
                        <v-layout>
                            <v-flex>
                                <v-icon color="green" :size="45">mdi-check-circle-outline</v-icon>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                บันทึกสำเร็จ!
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </div>
        </v-dialog>

        <!-- Dialog ลบสำเร็จ -->
        <v-dialog v-model="showDelSuccess" max-width="110" persistent>
            <div class="text-center">
                <v-card>
                    <v-card-text>
                        <v-layout>
                            <v-flex>
                                <v-icon color="green" :size="45">mdi-check-circle-outline</v-icon>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                ลบสำเร็จ!
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </div>
        </v-dialog>

    </v-app>
</template>
<script>
import mainMenu from '@/components/mainMenu'
import {db} from '@/firebase'
// import config from '@/components/config'
import axios from 'axios'
import XLSX from 'xlsx'
export default {
    components:{
        mainMenu
    },
    data(){
        return{
            // webPath:config.webPath,
            showDialogProgress: false,
            showWarning: false,
            msgWarning: '',
            showDialogError: false,
            msgError: '',
            showDialogSuccess: false,
            showDelSuccess: false,
            searchData: false,
            noData: true,
            
            menuDate: false,
            searchDate: new Date().toISOString().substr(0,10),
            nowDate: new Date().toISOString().substr(0,10),
            searchTransNo: '',
            detail: [],
            listHeader:[
                { text: 'เลขที่', align: 'left', value: 'transNo' },
                { text: 'วันที่ขึ้นของ', sortable: false, align: 'left', value: 'loadDate' },
                { text: 'วันที่ส่งของ', align: 'left', value: 'deliveryDate' },
                { text: 'คนขับรถ', sortable: false, align: 'left', value: 'driver' },
                { text: 'ทะเบียนรถ', sortable: false, align: 'left', value: 'regNum' },
                // { text: 'Export to Excel', sortable: false, align: 'center', value: 'excelAddress' },
                { text: '', sortable: false, align: 'left', value: 'action' },
                // { text: 'รายการจัดส่ง', sortable: false, align: 'left', value: 'listDelivery' },
                // { text: '', sortable: false, value: 'action' },
            ],
            manageList: [],

            dialogEditManageCar: false,
            dialogView: false,
            dialogEditSO: false,
            loadDate: '',
            deliveryDate: '',
            driver: '',
            regNum: '',
            transNo: '',
            listDelivery: [],

            prodHeader:[
                { text: 'เลขที่ SO', sortable: false, align: 'left', value: 'soNo' },
                { text: 'รหัสสินค้า', align: 'left', value: 'prodCode' },
                { text: 'โครง', sortable: false, align: 'center', value: 'frame' },
                { text: 'บาน', sortable: false, align: 'center', value: 'front' },
                { text: 'จำนวน', sortable: false, align: 'right', value: 'qty' },
                { text: 'ปริมาตร', sortable: false, align: 'right', value: 'volume' },
                { text: 'เกรด', sortable: false, align: 'center', value: 'grade' },
                { text: 'เลขที่ PO', sortable: false, align: 'left', value: 'poNo' },
                { text: 'หมายเหตุ', sortable: false, align: 'left', value: 'remark' },
                { text: '', sortable: false, value: 'action' },
            ],

            dialogSO: false,
            itemSoNo: [],
            soNo: '',
            idSO: '',
            rtNo: '',
            idRT: '',

            editLoadDate: '',
            editDelDate: '',
            editDriver: '',
            editRegNum: '',
            editCity: '',
            editCardCode: '',
            editCardName: '',
            editCardPhone: '',
            editCustAddress: '',
            editCustName: '',
            editCustTel: '',
            editSoNo: '',
            editRtNo: '',
            editTimeSt: '',
            editTimeEnd: '',

            driverItem: [],
            regNumItem: [],
            arrId: [],
            mcTransNo: '',
            menuEditLoadDate: false,
            mcLoadDate: '',
            menuEditDelDate: false,
            mcDelDate: '',
            mcDriver: '',
            mcRegNum: '',

            trackId: '',
        }
    },
    computed:{
        webPath(){
            return this.$store.getters.webPath
        },
    },
    methods:{

        // ดาวน์โหลดรายชื่อลูกค้าที่ต้องส่งสินค้า ด้วยการค้นหาจากเลขที่ใบจัดรถ เป็นไฟล์ .xlsx
        exportExcel(){
            let app = this
            if(!app.searchTransNo){
                app.msgError = "โปรดระบุเลขที่ใบจัดรถ"
                app.showDialogError = true
                setTimeout(()=>{
                    app.showDialogError = false
                    app.$nextTick(()=>app.$refs.searchTransNo.focus())
                },1500)
            }
            else{
                axios.post(this.webPath+'deliveryWebService.asmx/GetExportToExcel', {
                    transNo: app.searchTransNo
                })
                .then(response=>{
                    let resultSQL = JSON.parse(response.data.d)
                    if(resultSQL.length == 0){
                        app.msgError = "ไม่พบข้อมูลในระบบ โปรดลองใหม่อีกครั้ง"
                        app.showDialogError = true
                        setTimeout(()=>{
                            app.showDialogError = false
                            app.$nextTick(()=>app.$refs.searchTransNo.focus())
                        },1500)
                    }
                    else{
                        let arrDup = [], custName = null, custTel = null, custAddress = null, prodList = [], count = 0
                        resultSQL.forEach(rec=>{
                            if(rec.custName){
                                if(rec.custName != custName){
                                    if(count > 0){
                                        arrDup.push({ custName: custName, custTel: custTel, custAddress: custAddress, prodList: prodList })
                                    }
                                    custName = rec.custName
                                    custTel = rec.custTel
                                    custAddress = rec.custAddress
                                    prodList = []
                                    prodList.push({ prodCode: rec.prodCode, qty: rec.qty })
                                    count = 1
                                }
                                else{
                                    prodList.push({ prodCode: rec.prodCode, qty: rec.qty })
                                    count = 1
                                }
                            }
                            else{
                                if(rec.cardName != custName){
                                    if(count > 0){
                                        arrDup.push({ custName: custName, custTel: custTel, custAddress: custAddress, prodList: prodList })
                                    }
                                    custName = rec.cardName
                                    if(rec.cardPhone){
                                        let splitTel = rec.cardPhone.split(",")
                                        custTel = (splitTel[0] != 'NULL' ? splitTel[0] : '') + (splitTel[1] != 'NULL' ? ',' + splitTel[1] : '')
                                    }
                                    else{
                                        custTel = null
                                    }
                                    custAddress = rec.cardAddress
                                    prodList = []
                                    prodList.push({ prodCode: rec.prodCode, qty: rec.qty })
                                    count = 1
                                }
                                else{
                                    prodList.push({ prodCode: rec.prodCode, qty: rec.qty })
                                    count = 1
                                }
                            }
                        })
                        if(count > 0){
                            arrDup.push({ custName: custName, custTel: custTel, custAddress: custAddress, prodList: prodList })
                        }
                        arrDup.forEach(rec=>{
                            let i = 1
                            rec.prodList.forEach(prod=>{
                                rec["products"+ " " + i] = prod.prodCode + "  จำนวน " + prod.qty + " ตัว"
                                i++
                            })
                        })
                        arrDup.forEach(rec=>{
                            delete rec.prodList
                        })
                        // console.log(arrDup)
                        const dataWS = XLSX.utils.json_to_sheet(arrDup)
                        const wb = XLSX.utils.book_new()
                        XLSX.utils.book_append_sheet(wb, dataWS)
                        XLSX.writeFile(wb, app.searchTransNo+'.xlsx')
                    }
                })
            }
        },

        // หากเปลี่ยนวันขึ้นของ วันส่งของจะถูกเปลี่ยนตามด้วย *หน้าแก้ไขใบจัดรถ
        dateTransNo(){
            this.mcDelDate = this.mcLoadDate
        },

        // แสดงข้อมูลคนขับ
        getDriver(){
            let detail = []
            let app = this
            axios.post(this.webPath+'deliveryWebService.asmx/GetDriver', {
            })
            .then(response=> {
                detail = JSON.parse(response.data.d)
                detail.forEach(rec=>{
                    app.driverItem.push(rec.driverCode + " - " + rec.driverDesc)
                })
                // app.driverItem.sort((a, b) => a.driverCode.localeCompare(b.driverCode))
            })
            .then(()=>{
                if(app.$route.query.driver){
                    app.driverItem.forEach(rec=>{
                        let splitArr = rec.split(" - ")
                        let subArr = splitArr.filter(a=>a == app.$route.query.driver)
                        if(subArr.length > 0){
                            app.driver = rec
                        }
                    })
                }
            })
            .catch(()=> {
                this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : GetDriver() has error"
                this.showDialogError = true
            })
        },

        // แสดงข้อมูลทะเบียน
        getRegNum(){
            let detail = []
            let app = this
            axios.post(this.webPath+'deliveryWebService.asmx/GetRegNum', {
            })
            .then(response=> {
                detail = JSON.parse(response.data.d)
                detail.forEach(rec=>{
                    app.regNumItem.push(rec.regNum)
                })
            })
            .catch(()=> {
                this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : GetRegNum() has error"
                this.showDialogError = true
            })
        },

        // แสดงรายการจัดส่งสินค้า
        getDeliveryList(){
            this.searchTransNo = ''
            this.searchData = true
            this.noData = false
            // let nextMonth = new Date(this.searchDate)
            // nextMonth.setMonth(nextMonth.getMonth()+1)
            // nextMonth = nextMonth.toISOString().substr(0, 7)
            let app = this
            db.collection("deliveryList").where("deliveryDate", "==", this.searchDate).onSnapshot(querySnapshot=>{
                app.manageList = []
                let newArr = []
                let i = 0
                querySnapshot.forEach(doc=>{
                    newArr.push({ ...doc.data(), id: querySnapshot.docs[i].id })
                    i++
                })
                if(newArr.length == 0){
                    app.searchData = false
                    app.noData = true
                }
                else{
                    newArr.sort((a, b) => a.transNo.localeCompare(b.transNo))
                    let transNo = null
                    let loadDate = null
                    let deliveryDate = null
                    let id = []
                    let driver = null
                    let regNum = null
                    let count = 0
                    newArr.forEach(rec=>{
                        if(rec.transNo != transNo){
                            if(count > 0){
                                app.manageList.push({ transNo: transNo, loadDate: loadDate, deliveryDate: deliveryDate,
                                driver: driver, regNum: regNum, arrId: id})
                            }
                            id = []
                            id.push({ id: rec.id, soNo: rec.soNo, rtNo: rec.rtNo })
                            transNo = rec.transNo
                            loadDate = rec.loadDate
                            deliveryDate = rec.deliveryDate
                            driver = rec.driver
                            regNum = rec.regNum
                            count = 1
                        }
                        else{
                            id.push({ id: rec.id, soNo: rec.soNo, rtNo: rec.rtNo })
                            count++
                        }
                    })
                    if(count > 0){
                        app.manageList.push({ transNo: transNo, loadDate: loadDate, deliveryDate: deliveryDate,
                        driver: driver, regNum: regNum, arrId: id})
                    }
                }
            })
        },

        getTransNo(){
            if(!this.searchTransNo){
                this.$nextTick(()=>this.$refs.searchTransNo.focus())
            }
            else{
                this.searchData = true
                this.noData = false
                let app = this
                db.collection("deliveryList").where("transNo", "==", this.searchTransNo).onSnapshot(querySnapshot=>{
                    app.manageList = []
                    let newArr = []
                    let i = 0
                    querySnapshot.forEach(doc=>{
                        newArr.push({ ...doc.data(), id: querySnapshot.docs[i].id })
                        i++
                    })
                    if(newArr.length == 0){
                        app.searchData = false
                        app.noData = true
                    }
                    else{
                        newArr.sort((a, b) => a.transNo.localeCompare(b.transNo))
                        let transNo = null
                        let loadDate = null
                        let deliveryDate = null
                        let id = []
                        let driver = null
                        let regNum = null
                        let count = 0
                        newArr.forEach(rec=>{
                            if(rec.transNo != transNo){
                                if(count > 0){
                                    app.manageList.push({ transNo: transNo, loadDate: loadDate, deliveryDate: deliveryDate,
                                    driver: driver, regNum: regNum, arrId: id})
                                }
                                id = []
                                id.push({ id: rec.id, soNo: rec.soNo, rtNo: rec.rtNo })
                                transNo = rec.transNo
                                loadDate = rec.loadDate
                                deliveryDate = rec.deliveryDate
                                driver = rec.driver
                                regNum = rec.regNum
                                count = 1
                            }
                            else{
                                id.push({ id: rec.id, soNo: rec.soNo, rtNo: rec.rtNo })
                                count++
                            }
                        })
                        if(count > 0){
                            app.manageList.push({ transNo: transNo, loadDate: loadDate, deliveryDate: deliveryDate,
                            driver: driver, regNum: regNum, arrId: id})
                        }
                    }
                })
            }
        },

        // แก้ไขใบจัดส่งสินค้า เลขที่ที่เลือก
        editManageCar(item){
            this.arrId = item.arrId
            this.mcTransNo = item.transNo
            this.mcLoadDate = item.loadDate
            this.mcDelDate = item.deliveryDate
            this.mcDriver = item.driver
            this.mcRegNum = item.regNum
            this.dialogEditManageCar = true
        },

        // ยืนยันการแก้ไขใบจัดส่งสินค้า
        confiEditManageCar(){
            let app = this
            let arrSplit = app.mcDriver.split(" - ")
            this.showDialogProgress = true
            let i = 0
            this.arrId.forEach(rec=>{
                db.collection("deliveryList").doc(rec.id).update({
                    loadDate: app.mcLoadDate,
                    deliveryDate: app.mcDelDate,
                    driver: app.mcDriver,
                    driverName: arrSplit[1],
                    regNum: app.mcRegNum,
                    updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                    updateBy: sessionStorage.user
                })
                .then(()=>{
                    if(rec.soNo){
                        axios.post(app.webPath+'deliveryWebService.asmx/editSO', {
                            soNo: rec.soNo,
                            loadDate: app.mcLoadDate,
                            delDate: app.mcDelDate,
                            driver: arrSplit[0],
                            regNum: app.mcRegNum,
                        })
                        .catch(()=>{
                            app.showDialogProgress = false
                            app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : editSO() has error"
                            app.showDialogError = true
                        })
                    }
                    if(rec.rtNo){
                        axios.post(app.webPath+'deliveryWebService.asmx/editRT', {
                            rtNo: rec.rtNo,
                            loadDate: app.mcLoadDate,
                            delDate: app.mcDelDate,
                            driver: arrSplit[0],
                            regNum: app.mcRegNum,
                        })
                        .catch(()=>{
                            app.showDialogProgress = false
                            app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : editRT() has error"
                            app.showDialogError = true
                        })
                    }
                    i++
                    callback()
                })
            })
            let callback = function
            callback(){
                if(app.arrId.length === i){
                    app.showDialogProgress = false
                    app.showDialogSuccess = true
                    setTimeout(()=>{
                        app.dialogEditManageCar = false
                        app.showDialogSuccess = false
                    },2000)
                }
            }
        },

        // แก้ไข SO ที่เลือก
        editSO(item){
            this.editCustName = ''
            this.editCardName = ''
            this.editTimeSt = ''
            this.editTimeEnd = ''
            this.showDialogProgress = true
            this.idSO = item.id
            db.collection("deliveryList").doc(item.id).get()
            .then(query=>{
                let doc = query.data()
                // console.log(doc)
                this.editSoNo = item.soNo
                this.editRtNo = item.rtNo
                if(item.custName){
                    this.editCustName = item.custName
                }
                else{
                    this.editCardName = item.cardName
                }
                if(doc.time){
                    let splitTime = doc.time.split(" - ")
                    this.editTimeSt = splitTime[0]
                    this.editTimeEnd = splitTime[1]
                }
                this.dialogEditSO = true
                this.showDialogProgress = false
            })
        },

        // ยืนยันการแก้ไข SO
        confiEditSO(){
            this.showDialogProgress = true
            let time = null
            if(this.editTimeSt && this.editTimeEnd){
                time = this.editTimeSt + " - " + this.editTimeEnd
            }
            if(this.editTimeSt && this.editTimeEnd){
                if(this.editTimeSt.length != 5 || this.editTimeEnd.length != 5){
                    this.showDialogProgress = false
                    this.msgError = "โปรดระบุเวลาตามรูปแบบที่กำหนด 00:00"
                    this.showDialogError = true
                }
                else{
                    db.collection("deliveryList").doc(this.idSO).update({
                        time: time,
                        updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                        updateBy: sessionStorage.user
                    })
                    .then(()=>{
                        if(this.editSoNo){
                            axios.post(this.webPath+'deliveryWebService.asmx/editTimeSO', {
                                soNo: this.editSoNo,
                                serviceTime: time
                            })
                            .then(()=>{
                                this.showDialogProgress = false
                                this.showDialogSuccess = true
                                setTimeout(()=>{
                                    this.dialogEditSO = false
                                    this.showDialogSuccess = false
                                },2000)
                            })
                            .catch(()=>{
                                this.showDialogProgress = false
                                this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : editTimeSO() has error"
                            })
                        }
                        if(this.editRtNo){
                            axios.post(this.webPath+'deliveryWebService.asmx/editTimeRT', {
                                rtNo: this.editRtNo,
                                serviceTime: time
                            })
                            .then(()=>{
                                this.showDialogProgress = false
                                this.showDialogSuccess = true
                                setTimeout(()=>{
                                    this.dialogEditSO = false
                                    this.showDialogSuccess = false
                                },2000)
                            })
                            .catch(()=>{
                                this.showDialogProgress = false
                                this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : editTimeRT() has error"
                            })
                        }
                    })
                }
            }
            else{
                db.collection("deliveryList").doc(this.idSO).update({
                    time: time,
                    updateDate: new Date().toISOString().substr(0,10) + " " + new Date().toTimeString().substr(0,8),
                    updateBy: sessionStorage.user
                })
                .then(()=>{
                    if(this.editSoNo){
                        axios.post(this.webPath+'deliveryWebService.asmx/editTimeSO', {
                            soNo: this.editSoNo,
                            serviceTime: time
                        })
                        .then(()=>{
                            this.showDialogProgress = false
                            this.showDialogSuccess = true
                            setTimeout(()=>{
                                this.dialogEditSO = false
                                this.showDialogSuccess = false
                            },2000)
                        })
                        .catch(()=>{
                            this.showDialogProgress = false
                            this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : editTimeSO() has error"
                        })
                    }
                    if(this.editRtNo){
                        axios.post(this.webPath+'deliveryWebService.asmx/editTimeRT', {
                            rtNo: this.editRtNo,
                            serviceTime: time
                        })
                        .then(()=>{
                            this.showDialogProgress = false
                            this.showDialogSuccess = true
                            setTimeout(()=>{
                                this.dialogEditSO = false
                                this.showDialogSuccess = false
                            },2000)
                        })
                        .catch(()=>{
                            this.showDialogProgress = false
                            this.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : editTimeRT() has error"
                        })
                    }
                })
            }
        },

        // แสดงตัวอย่างใบจัดส่งสินค้า
        viewDeliveryList(item){
            db.collection("deliveryList").orderBy("time", "asc").where("transNo", "==", item.transNo).get()
            .then(querySnapshot=>{
                this.listDelivery = []
                querySnapshot.forEach(rec=>{
                    let doc = rec.data()
                    this.transNo = doc.transNo
                    this.loadDate = doc.loadDate
                    this.deliveryDate = doc.deliveryDate
                    this.driver = doc.driver
                    this.regNum = doc.regNum
                    this.listDelivery.push(doc)
                })
                this.listDelivery.forEach(rec=>{
                    rec.totalVolume = 0
                    rec.prodList.forEach(res=>{
                        rec.totalVolume += res.volume
                    })
                })
                this.dialogView = true
            })
        },

        // พิมพ์ใบจัดส่งสินค้า
        printDelivery(item){
            let routeData = this.$router.resolve({name: 'deliveryReport', query: {
                transNo: item.transNo
            }})
            window.open(routeData.href, "_blank")
        },

        // แสดงข้อมูล SO
        infoSo(item){
            this.showDialogProgress = true
            this.itemSoNo = []
            db.collection("deliveryList").where("transNo", "==", item.transNo).get()
            .then(query=>{
                let i = 0
                query.forEach(doc=>{
                    this.itemSoNo.push({ id: query.docs[i].id, soNo: doc.data().soNo, 
                    cardName: doc.data().cardName, custName: doc.data().custName, rtNo: doc.data().rtNo, transNo: item.transNo })
                    i++
                })
            })
            .then(()=>{
                this.showDialogProgress = false
                this.dialogSO = true
            })
        },

        // แสดงข้อความยืนยันการลบ
        openConfiDelSO(item){
            this.idSO = ''
            this.idRT = ''
            if(item.soNo){
                if(item.rtNo){
                    this.idRT = item.id
                    this.rtNo = item.rtNo
                }
                this.idSO = item.id
                this.soNo = item.soNo
                db.collection("deliveryTimeline").where("trackNo", "==", this.soNo).get()
                .then(query=>{
                    this.trackId = query.docs[0].id
                    this.msgWarning = "ต้องการลบเลขที่ " + this.soNo + " นี้ " + "ออกจากใบจัดส่งสินค้าเลขที่ " + item.transNo + " หรือไม่ ?"
                    this.showWarning = true
                })
            }
            else{
                this.idRT = item.id
                this.rtNo = item.rtNo
                db.collection("deliveryTimeline").where("trackNo", "==", this.rtNo).get()
                .then(query=>{
                    this.trackId = query.docs[0].id
                    this.msgWarning = "ต้องการลบเลขที่ " + this.rtNo + " นี้ " + "ออกจากใบจัดส่งสินค้าเลขที่ " + item.transNo + " หรือไม่ ?"
                    this.showWarning = true
                })
            }
        },

        // ยืนยันลบ So ออกจากใบจัดส่งสินค้า
        confiDel(){
            let app = this
            this.showDialogProgress = true
            if(app.idSO){
                axios.post(this.webPath+'deliveryWebService.asmx/CancelSo', {
                    soNo: app.soNo
                })
                .then(()=>{
                    db.collection("deliveryList").doc(app.idSO).delete()
                    .then(()=>{
                        db.collection("deliveryTimeline").doc(app.trackId).delete()
                        .then(()=>{
                            app.showDialogProgress = false
                            app.showDelSuccess = true
                            setTimeout(()=>{
                                app.showDelSuccess = false
                                app.showWarning = false
                                if(app.itemSoNo.length > 1){
                                    app.itemSoNo.splice(app.itemSoNo.findIndex(item=>item.id == app.idSO),1)
                                }
                                else{
                                    app.itemSoNo.splice(app.itemSoNo.findIndex(item=>item.id == app.idSO),1)
                                    app.dialogSO = false
                                }
                            },1000)
                        })
                    })
                    .catch(()=>{
                        app.msgError = "ไม่สามารถลบข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiDel() has error"
                        app.showDialogError = true
                    })
                })
                .catch(()=>{
                    this.msgError = "ไม่สามารถลบข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : CancelSo() has error"
                    this.showDialogError = true
                })
            }
            if(app.idRT){
                axios.post(this.webPath+'deliveryWebService.asmx/CancelRt', {
                    rtNo: app.rtNo
                })
                .then(()=>{
                    db.collection("deliveryList").doc(app.idRT).delete()
                    .then(()=>{
                        db.collection("deliveryTimeline").doc(app.trackId).delete()
                        .then(()=>{
                            app.showDialogProgress = false
                            app.showDelSuccess = true
                            setTimeout(()=>{
                                app.showDelSuccess = false
                                app.showWarning = false
                                if(app.itemSoNo.length > 1){
                                    app.itemSoNo.splice(app.itemSoNo.findIndex(item=>item.id == app.idRT),1)
                                }
                                else{
                                    app.itemSoNo.splice(app.itemSoNo.findIndex(item=>item.id == app.idRT),1)
                                    app.dialogSO = false
                                }
                            },1000)
                        })
                    })
                    .catch(()=>{
                        app.msgError = "ไม่สามารถลบข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : confiDel() has error"
                        app.showDialogError = true
                    })
                })
                .catch(()=>{
                    this.msgError = "ไม่สามารถลบข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : CancelRt() has error"
                    this.showDialogError = true
                })
            }
        },

        // 
        // exportExcel(item){
        //     db.collection("deliveryList").orderBy("cardCode").orderBy("custName").where("transNo", "==", item.transNo).get()
        //     .then(query=>{
        //         let arr = []
        //         query.forEach(doc=>{
        //             arr.push(doc.data())
        //         })
        //         let arrDup = [], custName = null, custTel = null, custAddress = null, prodList = [], count = 0
        //         arr.forEach(rec=>{
        //             if(rec.custName){
        //                 if(rec.custName != custName){
        //                     if(count > 0){
        //                         arrDup.push({ custName: custName, custTel: custTel, custAddress: custAddress, prodList: prodList })
        //                     }
        //                     custName = rec.custName
        //                     custTel = rec.custTel
        //                     custAddress = rec.custAddress
        //                     prodList = []
        //                     rec.prodList.forEach(prod=>{
        //                         let soNo = prod.soNo.toString().substr(0,1)
        //                         if(soNo != "2"){
        //                             prodList.push({ prodCode: prod.prodCode, qty: prod.qty })
        //                         }
        //                     })
        //                     count = 1
        //                 }
        //                 else{
        //                     rec.prodList.forEach(prod=>{
        //                         let soNo = prod.soNo.toString().substr(0,1)
        //                         if(soNo != "2"){
        //                             prodList.push({ prodCode: prod.prodCode, qty: prod.qty })
        //                         }
        //                     })
        //                     count = 1
        //                 }
        //             }
        //             else{
        //                 if(rec.cardName != custName){
        //                     if(count > 0){
        //                         arrDup.push({ custName: custName, custTel: custTel, custAddress: custAddress, prodList: prodList })
        //                     }
        //                     custName = rec.cardName
        //                     custTel = rec.custTel
        //                     custAddress = rec.custAddress
        //                     prodList = []
        //                     rec.prodList.forEach(prod=>{
        //                         let soNo = prod.soNo.toString().substr(0,1)
        //                         if(soNo != "2"){
        //                             prodList.push({ prodCode: prod.prodCode, qty: prod.qty })
        //                         }
        //                     })
        //                     count = 1
        //                 }
        //                 else{
        //                     rec.prodList.forEach(prod=>{
        //                         let soNo = prod.soNo.toString().substr(0,1)
        //                         if(soNo != "2"){
        //                             prodList.push({ prodCode: prod.prodCode, qty: prod.qty })
        //                         }
        //                     })
        //                     count = 1
        //                 }
        //             }
        //         })
        //         if(count > 0){
        //             arrDup.push({ custName: custName, custTel: custTel, custAddress: custAddress, prodList: prodList })
        //         }

        //         let newArr = []
        //         arrDup.forEach(rec=>{
        //             if(rec.prodList.length > 0){
        //                 newArr.push(rec)
        //             }
        //         })

        //         newArr.forEach(rec=>{
        //             let prodCode = null, qty = 0, i = 0
        //             rec.prodList.forEach(prod=>{
        //                 if(prod.prodCode != prodCode){
        //                     if(qty > 0){
        //                         rec["product"+ " " + i] = prodCode + "," + qty
        //                     }
        //                     prodCode = prod.prodCode
        //                     qty = prod.qty
        //                     i = 0
        //                     i++
        //                 }
        //                 else{
        //                     qty += prod.qty
        //                 }
        //             })
        //             if(qty > 0){
        //                 rec["product"+ " " + i] = prodCode + "," + qty
        //             }
        //         })

        //         newArr.forEach(rec=>{
        //             delete rec.prodList
        //         })
        //         console.log(newArr)
        //         // const dataWS = XLSX.utils.json_to_sheet(newArr)
        //         // const wb = XLSX.utils.book_new()
        //         // XLSX.utils.book_append_sheet(wb, dataWS)
        //         // XLSX.writeFile(wb, item.transNo+'.xlsx')
        //     })
        // }
    },
    mounted(){
        this.getDriver()
        this.getRegNum()
        this.getDeliveryList()
        // this.searchTransNo = "29768"
    }
}
</script>
<style scoped>
.line{
    border-bottom: 1px solid black;
    /* text-align: right; */
    width: 100%;
}
</style>
